import { render } from "./JobList.vue?vue&type=template&id=9b4027b8&scoped=true"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"

import "./JobList.vue?vue&type=style&index=0&id=9b4027b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4027b8"]])

export default __exports__